import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {LocalStorageWrapper} from "../local-storage-wrapper/local-storage-wrapper";

/*
  Generated class for the ContentTranslationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ContentTranslationProvider {

  translations: Map<string, string>
  initialized: boolean = false;

  constructor(public api: ApiProvider, public localStorage: LocalStorageWrapper) {
    this.translations = new Map<string, string>();
  }

  loadData() : Promise<boolean> {
    var me = this;
    return new Promise<boolean>((resolve, reject) => {
      if(this.initialized) {
        resolve(true);
        return ;
      }

      var resolved = false;
      if(this.localStorage.getItem('translations')) {
        this.loadTranslations(JSON.parse(this.localStorage.getItem('translations')));
        resolved = true;
        resolve(true);
      }

      this.api.callGet('/dictionary?v2=1').subscribe((data) => {
        console.log("load data response");
        me.loadTranslations(data);
        this.localStorage.setItem('translations', JSON.stringify(data))
        if(!resolved) {
          resolved = true;
          resolve(true);
        }
      })
    });
  }

  translateContent(content: string) {
    content = content.toLowerCase()
    if(this.translations.get(content)) {
      return this.translations.get(content);
    }
    if(this.initialized) {
      this.api.callPost('/dictionary', {phrase: content, translation: content}).subscribe(function(data) {
      })
    }
    this.translations.set(content, content);
    return content;
  }

  private loadTranslations(data: any) {
    for(var k in data) {
      this.translations.set(k.toLowerCase(), data[k]);
    }
    this.initialized = true;
  }
}



// WEBPACK FOOTER //
// ./src/providers/content-translation/content-translation.ts